import { Checkbox } from '@mui/material';

import './styles.scss';
import { CustomWidget } from '../../../../providers/model/custom-widget';

interface WidgetSelectProps {
  widget: CustomWidget;
  isChecked: boolean;
  onCheck: (checked: boolean) => void;
}

const WidgetSelect = ({ widget, isChecked, onCheck }: WidgetSelectProps) => {
  const icons = import.meta.glob('../../../../assets/widget-icons/*.svg', {
    import: 'default',
    eager: true,
  });

  const getImage = (key: string) => {
    const path = `../../../../assets/widget-icons/${key}.svg`;

    return icons[path] ?? icons['../../../../assets/widget-icons/vol-smile.svg'];
  };

  const imageUrl: any = getImage(widget.key);

  return (
    <div className="widget-container" onClick={() => onCheck(!isChecked)}>
      <label key={`${widget.key}`} className={`checkbox-item`} onClick={(e) => e.stopPropagation()}>
        <Checkbox checked={isChecked} onChange={(e) => onCheck(e.target.checked)} />
        <span className="label">{widget.title}</span>
      </label>
      <img src={imageUrl} alt={widget.title} className="widget-image" />
    </div>
  );
};

export default WidgetSelect;
